import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbCreate: PageLink[] = [
  {
    title: 'Serviços',
    path: '/commercial/services',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
